import { MenuItem } from "@mui/material";
import { OrganizationAddress } from "generated/graphql";
import { Link } from "react-router-dom";

export default function Update({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: OrganizationAddress["id"];
}) {
  return (
    <MenuItem component={Link} onClick={closeMenu} to={`/organization/addresses/${id}`}>
      Update Address
    </MenuItem>
  );
}
